import { useState } from 'react';

import usePreferredLocale from '@/hooks/usePreferredLocale';
import { getLocalizedArtworkMedium } from '@/pages/artwork/utils/artworkMediumDisplay.utils';
import ArtworksOfArtist from '@/pages/profile/artists/artworks-of-artist';
import UserProfileImage from '@/shared-components/cards/components/UserProfileImage';
import ArtistVerifiedIcon from '@/shared-components/icons/components/user-profile/ArtistVerifiedIcon';
import Text from '@/shared-components/text/components/Text';
import { getArtworkArtistDisplayName, getArtworkArtistSecondaryLine } from '@/utils/artworkArtists';

import ArtworkSocials from './ArtworkSocials';
import ArtworkTitle from './ArtworkTitle';

import './styles/ArtworkLabel.scss';

export default function ArtworkLabel({ artworkData, socialsData, onClickThought, onClickRating, onClickLike, hideSocials=false }) {
  const [artistToOpen, setArtistToOpen] = useState(null);
  const locale = usePreferredLocale();
  const hasClaimedArtist = Boolean(artworkData.artwork_about.artwork_artist);
  const artistUserFlags = artworkData?.artwork_about?.artwork_artist?.user_flags || {};
  const artistName = getArtworkArtistDisplayName(artworkData);
  const artistSecondaryLine = getArtworkArtistSecondaryLine(artworkData);
  const artworkMedium = getLocalizedArtworkMedium(artworkData, locale);

  const openArtistArtworks = () => {
    const artistData = hasClaimedArtist
      ? artworkData.artwork_about.artwork_artist
      : artworkData.artwork_about.artwork_gallery_artist;

    if (!artistData) {
      return;
    }

    setArtistToOpen(artistData);
  };

  return (
    <>
      <div className="artwork-label__container element-non-selectable">
        {
          hasClaimedArtist ?
            <div
              className="artwork-label__artist-section element-non-selectable"
              onClick={openArtistArtworks}
            >
              <UserProfileImage
                className="artwork-label__artist-image"
                typeOfProfile="artist"
                image={artworkData.artwork_about.artwork_artist.user_image?.image_id}
              />

              <div className="artwork-label__artist-name-section">
                <Text
                  className="artwork-label__artist-name dots-on-overflow font-size-large"
                  paragraph>
                  {artistName}
                  {artistUserFlags?.suarteroad_completed && (
                    <ArtistVerifiedIcon className="artwork-label__suarteroad-completed" />
                  )}
                </Text>

                {artistSecondaryLine ? (
                  <Text
                    className="artwork-label__artist-personal dots-on-overflow font-size-medium">
                    {artistSecondaryLine}
                  </Text>
                ) : null}
              </div>
            </div>
            :
            <>
              <div
                className="artwork-label__artist-section element-non-selectable no-artist"
                onClick={openArtistArtworks}
              >
                <div className="artwork-label__artist-name-section">
                  <Text
                    className="artwork-label__artist-name dots-on-overflow font-size-large"
                    paragraph>
                    {artistName}
                  </Text>

                  {artistSecondaryLine ? (
                    <Text
                      className="artwork-label__artist-personal dots-on-overflow font-size-medium">
                      {artistSecondaryLine}
                    </Text>
                  ) : null}
                </div>
              </div>
            </>
        }

        <ArtworkTitle artworkData={artworkData} />
                
        <Text className="artwork-label__artwork-details font-size-medium">
          {artworkMedium}
        </Text>

        <Text className="artwork-label__artwork-details font-size-medium">
          {artworkData.artwork_about.artwork_size.length}{' '}
          {artworkData.artwork_about.artwork_size.unit} x{' '}
          {artworkData.artwork_about.artwork_size.height}{' '}
          {artworkData.artwork_about.artwork_size.unit}
        </Text>

        <Text className="artwork-label__artwork-details font-size-medium">
          {artworkData.artwork_about.artwork_year}
        </Text>

        {!hideSocials && (
          <ArtworkSocials
            artworkData={artworkData}
            socialsData={socialsData}
            onClickThought={onClickThought}
            onClickRating={onClickRating}
            onClickLike={onClickLike}
          />
        )}
      </div>
      <ArtworksOfArtist
        open={Boolean(artistToOpen)}
        close={() => setArtistToOpen(null)}
        artist={artistToOpen}
        profileData={artworkData.artwork_about.artwork_gallery}
      />
    </>
  );
}
